export default __webpack_public_path__ + "images/7faef340612ce75146c7a229a692f465.jpg";